<template>
    <el-container>
        <el-main>
            <el-row>
                <td-table :columns="columns" :dataSource="tableData" :hasPage="false" ref="pkiInfo" :hasMutiSelect="false" :hasLoading="loading" :permissions="permissionsView"></td-table>
            </el-row>
        </el-main>
        <dialog-pkiInfo v-if="dialogPKIVisible" :dialogPKIVisible="dialogPKIVisible" :editItem="editItem" ref="pkiInfo" @dialogClose="dialogClose"></dialog-pkiInfo>
    </el-container>
</template>

<script>
import api from './assets/api.js';
import pkiInfo from './components/pkiInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-pkiInfo': pkiInfo
    },
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.query(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['pkiManage:view'],
            permissionsEdit: ['pkiManage:edit'],
            loading: false,
            dialogPKIVisible: false,
            editItem: {},
            columns: [
                {
                    prop: 'name',
                    label: 'pki.MANUFACTOR_NAME'
                },
                {
                    prop: 'path',
                    label: 'pki.MANUFACTOR_PATH'
                },
                {
                    prop: 'path',
                    label: 'pki.PKI_STATUS',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.status == 0) {
                            //启用
                            return createElement('span', this.$t('pki.PKI_ENABLE'));
                        } else {
                            //禁用
                            return createElement('span', this.$t('pki.PKI_DISABLE'));
                        }
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '300',
                    align: 'center',
                    render: (createElement, params) => {
                        //默认状态为启用，则按钮名称为禁用
                        let btnName = this.$t('pki.PKI_DISABLE');
                        if (params.row.status == 1) {
                            //如果状态为禁用，则按钮名称为启用
                            btnName = this.$t('pki.PKI_ENABLE');
                        }
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsEdit },
                                    on: {
                                        click: () => {
                                            this.btnEnable(params.row);
                                        }
                                    }
                                },
                                btnName
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsEdit },
                                    on: {
                                        click: () => {
                                            this.btnSet(params.row);
                                        }
                                    }
                                },
                                this.$t('pki.PKI_SET')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        pkilogin() {
            api.pkiLogin(JSON.stringify({}), response => {
                console.info('pkilogin---', response);
            });
        },
        // 查询数据
        query() {
            this.loading = true;
            api.listPKIInfo(JSON.stringify({}), response => {
                this.loading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/auth/pkiLogin/listPKIInfo', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/auth/pkiLogin/listPKIInfo', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
            });
        },
        btnEnable(row) {
            if (row.status == 1 && (this.$util.isEmpty(row.name) || this.$util.isEmpty(row.path))) {
                this.$message({ showClose: true, message: this.$t('pki.PKI_MANUFACTOR_INFO_NONE'), type: 'warning' });
                return;
            }
            let param = row;
            let msg = '';

            if (row.status == 0) {
                //禁用
                param.status = 1;
                msg = this.$t('pki.PKI_DISABLE_SUCCESS');
            } else if (row.status == 1) {
                // 启用
                param.status = 0;
                msg = this.$t('pki.PKI_ENABLE_SUCCESS');
            }

            api.editPKIInfo(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/auth/pkiLogin/editPKIInfo', response);
                    this.query();
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/auth/pkiLogin/editPKIInfo', response.data.statusMessage);
                    this.query();
                    return;
                }
                this.$message({ showClose: true, message: msg, type: 'success' });
                this.query();
            });
        },
        btnSet(row) {
            this.editItem = row;
            this.dialogPKIVisible = true;
        },
        dialogClose() {
            this.dialogPKIVisible = false;
            this.query();
        }
    }
};
</script>
<style></style>
